import type { AppointmentsOverviewFiltersForm } from './AppointmentsOverviewFilters.types';

export const EMPTY_FILTERS: AppointmentsOverviewFiltersForm = {
  selections: [],
  activityIds: []
};

/**
 * How many filters the trigger's badge reports: one per field that has something in it, not one per value —
 * three people and two activities is two filters, as on the takenlijst.
 */
export const countActiveFilters = ({
  selections,
  activityIds
}: AppointmentsOverviewFiltersForm): number =>
  [selections, activityIds].filter(({ length }) => length > 0).length;
